import { createFileRoute } from '@tanstack/react-router'

import { ContactsPanel } from '@/components/clients/contacts-panel'
import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { matching, readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId/contacts')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /** Lot 19 (`web_path`) : le contact désigné, épinglé et surligné. */
        contact: matching(/^[0-9a-f]{24}$/),
      },
      search,
    ),
  component: ClientContactsPage,
})

function ClientContactsPage() {
  const client = useShellClient()
  const { contact } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <Frame>
      <ContactsPanel
        client={client}
        focusId={contact}
        onDismissFocus={() => {
          void navigate({ search: { contact: undefined }, replace: true })
        }}
      />
    </Frame>
  )
}
